import React from 'react';
import './Styles.css'

export class Footer extends React.Component {
    render() {
        return (
            <React.Fragment>
                <footer className="footer">
                    <p>Develop with Love by Beta</p>
                </footer>

            </React.Fragment>
        )
    }
}

export default Footer;